// extracted by css-extract-rspack-plugin
export default {"cls1":"blurred_takeaways-cls1_mLs","cls2":"blurred_takeaways-cls2_Faw blurred_takeaways-cls1_mLs"};